import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

//console.clear();


ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById("root")
);
reportWebVitals();


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//Utils.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

